import React from 'react'
import { View } from 'react-native'
import { useSelector } from 'react-redux';
import SevenRooms from './sevenrooms';

const Reservations = () => {
    const { webAppWidgetsInfo } = useSelector(state => state.deviceConfigSlice);

    const restaurantReservationInterfaceCode = webAppWidgetsInfo?.appConfigs?.restaurantReservationConfigs?.restaurantReservationInterfaceCode;
    return restaurantReservationInterfaceCode == "SEVENROOMS" ? 
        <SevenRooms />
     : null
}

export default Reservations
